import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Cookies} from "react-cookie";
import {LangContext} from "./LangContext";
import {COOKIE_KEY, LANG_KEY} from "../../constants";

const cookies = new Cookies();

interface LangProviderProps {
  children: React.ReactNode
}

export const LangProvider: React.FC<LangProviderProps> = ({children}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  const [lang, setLang] = useState<string>(langParam || LANG_KEY.RU);
  // const [lang, setLang] = useState<string>(cookies.get(COOKIE_KEY.LANG) || LANG_KEY.RU)
  const {i18n} = useTranslation();

  // useEffect(() => {
  //   const langHandler = (options: any) => {
  //     if (options.name === COOKIE_KEY.LANG && options.value) {
  //       setLang(options.value);
  //       i18n.changeLanguage(options.value);
  //       window.location.reload()
  //     }
  //   }

  //   cookies.addChangeListener((options) => {
  //     langHandler(options)
  //   })

  //   return () => {
  //     cookies.removeChangeListener((options) => {
  //       langHandler(options)
  //     })
  //   }

  // }, [])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');

    if (langParam) {
      setLang(langParam);
      i18n.changeLanguage(langParam);
    }
  }, []);

  // const handleChangeLang = (value: string) => {
  //   if (lang === LANG_KEY.RU) {
  //     cookies.set(COOKIE_KEY.LANG, LANG_KEY.KZ, {path: '/'})
  //     setLang(LANG_KEY.KZ)
  //   }
  //   else {
  //     cookies.set(COOKIE_KEY.LANG, LANG_KEY.RU, {path: '/'})
  //     setLang(LANG_KEY.RU)
  //   }
  // }

  // const handleChangeLang = (value: string) => {
  //   if (value === LANG_KEY.KZ) {
  //     cookies.set(COOKIE_KEY.LANG, LANG_KEY.KZ, { path: "/" });
  //     setLang(LANG_KEY.KZ);
  //   } else if (value === LANG_KEY.RU) {
  //     cookies.set(COOKIE_KEY.LANG, LANG_KEY.RU, { path: "/" });
  //     setLang(LANG_KEY.RU);
  //   } else if (value === LANG_KEY.AR) {
  //     cookies.set(COOKIE_KEY.LANG, LANG_KEY.AR, { path: "/" });
  //     setLang(LANG_KEY.AR);
  //   } else if (value === LANG_KEY.EN) {
  //     cookies.set(COOKIE_KEY.LANG, LANG_KEY.EN, { path: "/" });
  //     setLang(LANG_KEY.EN);
  //   }
  // };

  const handleChangeLang = (value: string) => {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    const currentLang = searchParams.get('lang');

    if (currentLang === value) {
      return;
    }

    searchParams.set('lang', value);

    const newUrl = `${url.pathname}?${searchParams.toString()}${url.hash}`;
    window.location.replace(newUrl);
  };

  const value = {lang, handleChangeLang}

  return (
    <LangContext.Provider value={value}>{children}</LangContext.Provider>
  );
}
